import { Client } from "@seneca/client-library";

const DEFAULT_LIVE_FEED_LIMIT = 25;

export default class LiveFeedServiceClient extends Client {
  async fetchFeedEvents({
    userId,
    limit = DEFAULT_LIVE_FEED_LIMIT
  }: {
    userId: string;
    limit?: number;
  }) {
    const url = `${this.url}/api/live-feed-events/${userId}?limit=${limit}`;
    const expectedResponses = [200, 403];

    const response = await this.requestMaker.makeRequest<any>(
      url,
      { method: "GET" },
      expectedResponses
    );

    return response.json;
  }
}
